import React from 'react'
import { AiFillYoutube } from "react-icons/ai";
import { FaFacebookSquare, FaWhatsapp  } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";
import { BiSolidPhoneCall } from "react-icons/bi";
import './smedia.scss'
import { Link } from 'react-router-dom';

export default function SocialMediaPhoto() {
    return (
        <div className='social-content' >
            <a href="tel:+94768309969" target="_blank" rel="noopener noreferrer"><i className='socialIcon'><BiSolidPhoneCall /></i></a>
            <a href="https://wa.link/q1edqi" target="_blank" rel="noopener noreferrer"><i className='socialIcon'><FaWhatsapp /></i></a>
            <a href="mailto:abilasha@abiwic.com" target="_blank" rel="noopener noreferrer"><i className='socialIcon'><IoIosMail /></i></a>
            <a href="https://web.facebook.com/abicaptures" target="_blank" rel="noopener noreferrer"><i className='socialIcon'><FaFacebookSquare/></i></a>
            <a href="https://www.youtube.com/@abi-po9rx?sub_confirmation=1" target="_blank" rel="noopener noreferrer"><i className='socialIcon'><AiFillYoutube /></i></a>
        </div>
    )
}
